import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { majorScale, minorScale, Pane } from 'evergreen-ui';

function TableHead({ headings }) {
  return (
    <Pane is="thead">
      <Pane is="tr">
        {headings.map((heading, i) => (
          <Pane
            key={i}
            is="th"
            paddingY={minorScale(3)}
            paddingX={majorScale(2)}
            textAlign="left"
            whiteSpace="nowrap"
            boxShadow="inset 0px -1px 0px #EDF0F2"
            fontSize=".9em"
            fontWeight={700}
            fontFamily="Open Sans, sans-serif"
          >
            {heading}
          </Pane>
        ))}
      </Pane>
    </Pane>
  );
}

function TableBody({ data = [], onRowClick }) {
  function handleRowClick({ currentTarget }) {
    if (onRowClick === undefined) return null;

    if (typeof onRowClick !== 'function') {
      throw new Error('Table row click handler is not a function');
    }

    var idField = currentTarget.dataset.id;
    if (idField === 'undefined') {
      throw new Error('Cannot find key property of table row');
    }

    if (typeof idField !== 'string') {
      throw new Error('Table row key is not a string');
    }

    onRowClick(idField);
  }

  return (
    <Pane is="tbody" backgroundColor="#fff">
      {data.map((item, i) => {
        var { idField, ...rest } = item;

        return (
          <tr key={i} data-id={idField} onClick={handleRowClick}>
            {Object.values(rest).map((content, i) => (
              <Pane
                key={i}
                is="td"
                paddingY={minorScale(3)}
                paddingX={majorScale(2)}
                whiteSpace="nowrap"
                boxShadow="inset 0px -1px 0px #EDF0F2"
                fontSize=".9em"
                fontFamily="Proxima Nova, sans-serif"
              >
                {content}
              </Pane>
            ))}
          </tr>
        );
      })}
    </Pane>
  );
}

const StyledTable = styled.table`
  min-width: 100%;
  border-collapse: collapse;

  &[data-hover='true'] tbody tr:hover {
    cursor: pointer;
    /* box-shadow: inset 0 0px 4px 0 rgba(0, 0, 0, 0.12); */
  }
`;

function Table({ headings, data, onRowClick }) {
  return (
    <Pane overflow="auto">
      <Pane
        display="inline-block"
        minWidth="100%"
        verticalAlign="middle"
        overflow="hidden"
      >
        <StyledTable data-hover={typeof onRowClick === 'function'}>
          {headings && <TableHead headings={headings} />}
          <TableBody data={data} onRowClick={onRowClick} />
        </StyledTable>
      </Pane>
    </Pane>
  );
}

Table.propTypes = {
  data: PropTypes.array,
  headings: PropTypes.array,
  onRowClick: PropTypes.func,
};

export default Table;
